<template>
  <v-list-item>
    <v-list-item-content>
      <v-list-item-title class="text-wrap">Изменить администраторский код</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-dialog v-model="adminCode" persistent max-width="400">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" class="text-none" rounded>
            Выбрать
          </v-btn>
        </template>
        <v-card>
          <v-card-title>Измените администраторский код</v-card-title>
          <v-text-field
            ref="adminCode"
            v-model="adminCodeNew"
            label="Введите код"
            class="pa-5"
            outlined
            dense
            flat
            required
            :rules="[
              v => !!v || 'Обязательное поле',
              v => (v.length === 4) || '4-значный номер',
            ]"
          ></v-text-field>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              class="text-none"
              @click="adminCode = false"
            >
              Отменить
            </v-btn>
            <v-btn
              color="success"
              @click="updateAdminCodeNew"
              :loading="isloading"
              :disabled="adminCodeNew === ''"
            >
              Загрузить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogResult" max-width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2">
            Результат
          </v-card-title>
          <v-card-text>
            <v-col v-if="issetRightDoorphones()">
              <h3>Успешно изменён на домофонах:</h3>
              <ul>
                <li v-for="(doorphone) in updateResult.right_doorphones" :key="doorphone.id">
                  {{ doorphone.id }} - {{ doorphone.address }}, п.{{ doorphone.entrance }}
                </li>
              </ul>
            </v-col>
            <v-col v-if="issetFailDoorphones()">
              <h3>Не удалось изменить на домофонах:</h3>
              <ul>
                <li v-for="(doorphone) in updateResult.fail_doorphones" :key="doorphone.id">
                  {{ doorphone.id }} - {{ doorphone.address }}, п.{{ doorphone.entrance }}
                </li>
              </ul>
            </v-col>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="dialogResult = false"
            >
              Закрыть
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'AdminCode',
  props: ['doorphones'],
  data () {
    return {
      adminCode: false,
      isloading: false,
      adminCodeNew: '',
      dialogResult: false,
      updateResult: {},
    };
  },
  methods: {
    ...mapActions({
      updateMassAdminCode: 'MainSetups/updateMassAdminCode',
    }),
    updateAdminCodeNew () {
      this.$refs.adminCode.validate(true);
      this.$nextTick(() => {
        if (this.adminCodeNew !== '') {
          const selectedDoorphoneId = this.doorphones.map(doorphone => { return doorphone.id; });

          this.isloading = true;
          this.updateMassAdminCode({
            adminCode: this.adminCodeNew,
            doorphones: selectedDoorphoneId,
          })
            .then((res) => {
              this.adminCodeNew = '';
              this.adminCode = false;
              this.updateResult = res;
              this.dialogResult = true;
            })
            .catch((error) => {
              this.$flash_warning('Не удолось поменять код.');
              console.error(error);
            })
            .finally(() => {
              this.isloading = false;
            });
        }
      });
    },
    issetRightDoorphones () {
      return this.updateResult.right_doorphones && this.updateResult.right_doorphones.length > 0;
    },
    issetFailDoorphones () {
      return this.updateResult.fail_doorphones && this.updateResult.fail_doorphones.length > 0;
    },
  },
};
</script>

<style scoped>

</style>
